module.exports = __webpack_public_path__ + "static/media/fieldclick.4c10ea03.wav";